import {Injectable} from '@angular/core';
import {Command} from '@application/command/command';
import {DialogBuilderFactoryService, DialogType, TranslateService} from '@vdw/angular-component-library';
import {isEmpty, join, lowerCase, size} from 'lodash-es';
import {ShowProductionOrderIncompatibleWithMachineAlertParameters} from './show-production-order-incompatible-with-machine-alert-parameters';

@Injectable()
export class ShowProductionOrderIncompatibleWithMachineAlertCommand implements Command<ShowProductionOrderIncompatibleWithMachineAlertParameters, void> {
  public constructor(
    private readonly translate: TranslateService,
    private readonly dialogBuilderFactoryService: DialogBuilderFactoryService
  ) {}

  public execute({error, productionOrderName, machineName}: ShowProductionOrderIncompatibleWithMachineAlertParameters): void {
    const INCOMPATIBLE_MESSAGE_KEY = 'PLANNING.ERRORS.INCOMPATIBLE_PRODUCTION_ORDER';
    const translationParams = {
      productionOrderName,
      machineName: isEmpty(machineName) ? this.translate.instant('GENERAL.NO_DATA', {object: lowerCase(this.translate.instant('GENERAL.NAME'))}) : machineName,
      amountOfCompatibleMachines: size(error.errorContext.linkedEntityNames)
    };

    if (!isEmpty(error.errorContext.linkedEntityNames)) {
      translationParams['compatibleMachinesList'] = join(error.errorContext.linkedEntityNames, ', ');
    }

    this.dialogBuilderFactoryService.getBuilder().openAlertDialog({
      titleText: this.translate.instant('PLANNING.ERRORS.INCOMPATIBLE_ENTITY', {entity: lowerCase(this.translate.instant('PRODUCTION_ORDER.PRODUCTION_ORDER', {count: 1}))}),
      messageText: this.translate.instant(INCOMPATIBLE_MESSAGE_KEY, translationParams),
      type: DialogType.INFORMATION
    });
  }
}
